angular
    .module('app.controllers')
    .controller('DashboardTasksCtrl', function ($scope, $timeout, $translate, $localStorage, $log, uiCalendarConfig, api, notify, UserService, usersOptions) {
        const vm = this;

        const defaultSettings = {
            date: moment(),
            users: [UserService.getUser().id.toString()],
        };

        $localStorage.$default({
            dashboardTasks: defaultSettings,
        });

        vm.firstRender = true;
        vm.eventSources = [[]];
        vm.taskUsers = angular.copy($localStorage.dashboardTasks.users);
        vm.userOptions = usersOptions;

        $scope.$watch(
            'DashboardTasks.taskUsers',
            _.debounce((users) => {
                $log.debug('> reload list to show tasks for users: ', users);
                $localStorage.dashboardTasks.users = users;
                vm.loadList();
            }, 1000)
        );

        const defaultDate = $localStorage.dashboardTasks.date;

        vm.uiConfig = {
            calendar: {
                header: {
                    left: 'chooseDate',
                    center: 'title',
                    right: 'month,listMonth,agendaWeek,listWeek,agendaDay prev,next',
                },
                buttonIcons: {
                    prev: 'md-left-single-arrow',
                    next: 'md-right-single-arrow',
                    prevYear: 'md-left-double-arrow',
                    nextYear: 'md-right-double-arrow',
                },
                customButtons: {
                    chooseDate: {
                        text: ' ',
                    },
                },
                buttonText: {
                    today: ' ',
                    month: ' ',
                    week: ' ',
                    day: ' ',
                },
                locale: 'pl',
                aspectRatio: 2.1,
                defaultDate: defaultDate,
                selectable: true,
                selectHelper: true,
                select(start, end) {},
                viewRender(view, element) {
                    $log.debug("Calendar's View Changed", view);
                    if (vm.firstRender) {
                        // podmiana ikony
                        $timeout(() => {
                            angular.element('.fc-chooseDate-button').html('<em class="material-icons md-24">date_range</em>');
                        });
                        // przechodzenie do wybranej daty
                        $timeout(() => {
                            const datepicker = UIkit.datepicker(angular.element('.fc-chooseDate-button .material-icons'));
                            datepicker.on('hide.uk.datepicker', () => {
                                vm.goToDate(datepicker.current.format('YYYY-MM-DD'));
                            });
                        });
                    }

                    if ('month' === view.name) {
                        // zapamiętujemy datę ze środka miesiąca, aby uniknać skakania
                        $localStorage.dashboardTasks.date = view.start.add(14, 'days').format('YYYY-MM-DD');
                    } else {
                        $localStorage.dashboardTasks.date = view.start.format('YYYY-MM-DD');
                    }

                    vm.firstRender = false;
                },
                editable: true,
                eventLimit: true,
                timeFormat: '(HH)(:mm)',
            },
        };

        vm.goToDate = (date) => {
            uiCalendarConfig.calendars['tasksCalendar'].fullCalendar('gotoDate', date);
        };

        const TasksModel = api('tasks');
        vm.loadList = () => {
            const info = notify.info($translate.instant('loading'));
            notify.global(1);

            TasksModel.stop()
                .list({ data: { users: vm.taskUsers } })
                .then((response) => {
                    const tasks = [];

                    angular.forEach(response.data, (task) => {
                        tasks.push({
                            title: task.name,
                            start: task.date_from.substr(0, 10),
                            end: task.date_to.substr(0, 10),
                            url: `/tasks/edit/${task.id}`,
                            color: `#${task.color}`,
                        });
                    });

                    info.close();
                    notify.success($translate.instant('loaded'));
                    notify.global(0);

                    $timeout(() => {
                        vm.eventSources[0] = tasks;
                    }, 250);
                });
        };

        vm.resetSavedSettings = () => {
            $localStorage.dashboardTasks = defaultSettings;
            vm.taskUsers = $localStorage.dashboardTasks.users;

            vm.goToDate($localStorage.dashboardTasks.date);
        };
    });
